/**
 * Franklin Obsidian Shopify Theme Javascript Engine
 * Uses real Shopify AJAX Cart API
 */

document.addEventListener('DOMContentLoaded', () => {
  initTheme();
  initMiniCart();
  initQuickView();
  initHeroSlider();
  initScrollReveal();
});

// Color hex map for variant swatches
function getColorHex(colorName) {
  const map = {
    'black': '#000000',
    'white': '#FFFFFF',
    'chrome silver': '#C0C0C0',
    'silver': '#C0C0C0',
    'neon volt': '#CCFF00',
    'dark navy': '#1B2A4A',
    'dark gray': '#555555',
    'brown': '#8B4513'
  };
  return map[(colorName || '').toLowerCase().trim()] || '#CBD5E1';
}

// Global Theme State
window.FranklinStore = {
  cart: { items: [], item_count: 0, total_price: 0 }
};

// 1. UNIFIED THEME INITIALIZATION
function initTheme() {
  document.documentElement.style.setProperty('--color-sport-accent', '#D6FF00');
  document.documentElement.style.setProperty('--color-sport-accent-solid', '#D6FF00');
  document.documentElement.style.setProperty('--color-sport-accent-muted', 'rgba(214, 255, 0, 0.15)');
  document.documentElement.style.setProperty('--color-sport-rgb', '214, 255, 0');
}

// 2. HERO IMAGE SLIDER ENGINE & DRAGGING
let currentSlide = 0;
let totalSlides = 0;
let autoSlideInterval;

function initHeroSlider() {
  const inner = document.getElementById('hero-slider-inner');
  if (!inner) return;
  totalSlides = inner.children.length;
  if (totalSlides === 0) return;
  currentSlide = 0;
  updateHeroSlider();
  if (totalSlides > 1) {
    startAutoSlide();
    initDraggableHeroSlider();
  }
}

window.slideHero = function(direction) {
  clearInterval(autoSlideInterval);
  if (direction === 'next') {
    currentSlide = (currentSlide + 1) % totalSlides;
  } else {
    currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
  }
  updateHeroSlider();
  startAutoSlide();
};

window.goHeroSlide = function(index) {
  clearInterval(autoSlideInterval);
  currentSlide = index;
  updateHeroSlider();
  startAutoSlide();
};

function updateHeroSlider() {
  const inner = document.getElementById('hero-slider-inner');
  if (!inner) return;
  inner.style.transform = `translateX(-${(currentSlide * 100) / totalSlides}%)`;

  for (let i = 0; i < totalSlides; i++) {
    const dot = document.getElementById(`hero-dot-${i}`);
    if (dot) {
      if (i === currentSlide) {
        dot.className = 'w-3 h-3 border border-white bg-[#D6FF00] transition-all duration-300';
      } else {
        dot.className = 'w-3 h-3 border border-white bg-white/30 hover:bg-[#D6FF00] transition-all duration-300';
      }
    }
  }
}

function startAutoSlide() {
  autoSlideInterval = setInterval(() => {
    currentSlide = (currentSlide + 1) % totalSlides;
    updateHeroSlider();
  }, 5000);
}

function initDraggableHeroSlider() {
  const sliderSection = document.getElementById('hero-slider-section');
  const sliderInner = document.getElementById('hero-slider-inner');
  if (!sliderSection || !sliderInner) return;

  let startX = 0;
  let currentX = 0;
  let isDragging = false;
  let suppressClick = false;
  let startLink = null;
  let dragThreshold = 70;
  let clickThreshold = 5;

  // setPointerCapture (below) makes Chrome swallow the native click on the slide's
  // <a>, so we navigate ourselves on a tap. This listener kills any native click
  // that does slip through (drag end, or browsers that still fire it) to avoid
  // double navigation / mid-swipe jumps.
  sliderSection.addEventListener('click', (e) => {
    if (suppressClick) {
      e.preventDefault();
      e.stopPropagation();
      suppressClick = false;
    }
  }, true);

  sliderSection.addEventListener('pointerdown', (e) => {
    suppressClick = false;
    if (e.button !== undefined && e.button !== 0) return;
    // Let the nav buttons (arrows/dots) handle their own clicks; slide links are draggable.
    if (e.target.closest('button')) return;

    isDragging = true;
    startLink = e.target.closest('a');
    startX = e.clientX;
    currentX = startX;

    clearInterval(autoSlideInterval);
    sliderInner.style.transition = 'none';

    sliderSection.classList.remove('cursor-grab');
    sliderSection.classList.add('cursor-grabbing');

    sliderSection.setPointerCapture(e.pointerId);
  });

  sliderSection.addEventListener('pointermove', (e) => {
    if (!isDragging) return;
    currentX = e.clientX;
    const deltaX = currentX - startX;

    if (Math.abs(deltaX) < clickThreshold) return;

    const containerWidth = sliderSection.clientWidth;
    const slideWidthPercent = 100 / totalSlides;
    const baseTranslate = -(currentSlide * slideWidthPercent);
    const dragPercent = (deltaX / containerWidth) * 100;
    const newTranslate = baseTranslate + (dragPercent / totalSlides);

    sliderInner.style.transform = `translateX(${newTranslate}%)`;
  });

  const handleDragEnd = (e) => {
    if (!isDragging) return;
    isDragging = false;

    try {
      sliderSection.releasePointerCapture(e.pointerId);
    } catch (err) {}

    sliderInner.style.transition = '';
    sliderSection.classList.remove('cursor-grabbing');
    sliderSection.classList.add('cursor-grab');

    const deltaX = currentX - startX;
    const moved = Math.abs(deltaX) > clickThreshold;

    // We manage navigation ourselves — swallow whatever native click may follow.
    suppressClick = true;

    if (moved) {
      if (deltaX < -dragThreshold) {
        currentSlide = (currentSlide + 1) % totalSlides;
      } else if (deltaX > dragThreshold) {
        currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
      }
    } else if (startLink && startLink.getAttribute('href')) {
      // A tap on a slide link — navigate explicitly.
      if (startLink.target === '_blank') {
        window.open(startLink.href, '_blank', 'noopener');
      } else {
        window.location.href = startLink.href;
      }
    }

    startLink = null;
    updateHeroSlider();
    startAutoSlide();
  };

  sliderSection.addEventListener('pointerup', handleDragEnd);
  sliderSection.addEventListener('pointercancel', handleDragEnd);
  sliderSection.addEventListener('pointerleave', handleDragEnd);

  sliderInner.querySelectorAll('img').forEach(img => {
    img.addEventListener('dragstart', (e) => e.preventDefault());
  });
}

// 3. SCROLL REVEAL ACTIVATOR
function initScrollReveal() {
  const revealItems = document.querySelectorAll('.reveal-item');
  if (revealItems.length === 0) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    threshold: 0.08,
    rootMargin: '0px 0px -40px 0px'
  });

  revealItems.forEach((item) => {
    observer.observe(item);
  });
}

// 4. MINI-CART DRAWER CONTROLS
function initMiniCart() {
  window.toggleCartDrawer = function(open) {
    const drawer = document.getElementById('cart-drawer');
    const panel = document.getElementById('cart-panel');
    if (!drawer || !panel) return;

    if (open) {
      drawer.classList.remove('opacity-0', 'pointer-events-none');
      panel.classList.remove('translate-x-full');
    } else {
      drawer.classList.add('opacity-0', 'pointer-events-none');
      panel.classList.add('translate-x-full');
    }
  };

  fetchCart();
}

// ============================================
// SHOPIFY AJAX CART API
// ============================================

function getRouteRoot() {
  return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
}

function fetchCart() {
  const root = getRouteRoot();
  return fetch(root + 'cart.js')
    .then(res => res.json())
    .then(cart => {
      window.FranklinStore.cart = cart;
      updateCartUI();
      return cart;
    })
    .catch(err => console.warn('Error fetching cart:', err));
}

window.addToCart = function(variantId, quantity, triggerButton) {
  quantity = quantity || 1;

  // Find the clicked button for loading state
  const btn = triggerButton || document.activeElement;
  let originalContent = '';
  if (btn && btn.tagName === 'BUTTON') {
    originalContent = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = `<svg class="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>`;
  }

  const root = getRouteRoot();
  fetch(root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: quantity })
  })
    .then(res => {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(() => {
      // Show success state on button
      if (btn && btn.tagName === 'BUTTON') {
        btn.innerHTML = `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"></path></svg> ${(window.themeStrings && window.themeStrings.added) || 'Added!'}`;
      }

      // Trigger bounce animation on cart button
      const cartBtn = document.getElementById('cart-trigger-btn');
      if (cartBtn) {
        cartBtn.classList.remove('animate-cart-pop');
        void cartBtn.offsetWidth;
        cartBtn.classList.add('animate-cart-pop');
        setTimeout(() => cartBtn.classList.remove('animate-cart-pop'), 450);
      }

      return fetchCart();
    })
    .then(() => {
      toggleCartDrawer(true);
      // Restore button after drawer opens
      setTimeout(() => {
        if (btn && btn.tagName === 'BUTTON') {
          btn.innerHTML = originalContent;
          btn.disabled = false;
        }
      }, 600);
    })
    .catch(err => {
      console.error('Add to cart error:', err);
      if (btn && btn.tagName === 'BUTTON') {
        btn.innerHTML = originalContent;
        btn.disabled = false;
      }
    });
};

function showCartLoading() {
  const panel = document.getElementById('cart-panel');
  if (!panel) return;
  let overlay = panel.querySelector('.cart-loading-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'cart-loading-overlay absolute inset-0 bg-white/80 z-50 flex items-center justify-center transition-opacity duration-200';
    overlay.innerHTML = '<svg class="w-8 h-8 animate-spin text-black" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>';
    panel.appendChild(overlay);
  }
  overlay.style.display = 'flex';
}

function hideCartLoading() {
  const overlay = document.querySelector('.cart-loading-overlay');
  if (overlay) overlay.style.display = 'none';
}

window.removeCartItem = function(lineKey) {
  showCartLoading();
  const root = getRouteRoot();
  fetch(root + 'cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: 0 })
  })
    .then(res => res.json())
    .then(cart => {
      window.FranklinStore.cart = cart;
      updateCartUI();
      hideCartLoading();
    })
    .catch(err => {
      console.error('Remove cart item error:', err);
      hideCartLoading();
    });
};

window.updateCartItemQty = function(lineKey, newQuantity) {
  if (newQuantity <= 0) {
    return removeCartItem(lineKey);
  }

  showCartLoading();
  const root = getRouteRoot();
  fetch(root + 'cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: newQuantity })
  })
    .then(res => res.json())
    .then(cart => {
      window.FranklinStore.cart = cart;
      updateCartUI();
      hideCartLoading();
    })
    .catch(err => {
      console.error('Update cart qty error:', err);
      hideCartLoading();
    });
};

// Format money to exactly match the store's Liquid `| money` output, then strip the ISO code
function formatMoney(cents) {
  if (typeof cents === 'string') { cents = cents.replace('.', ''); }
  var format = window.SHOP_MONEY_FORMAT || '${{amount}}';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = (precision === undefined) ? 2 : precision;
    thousands = (thousands === undefined) ? ',' : thousands;
    decimal = (decimal === undefined) ? '.' : decimal;
    if (isNaN(number) || number == null) { return '0'; }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsPart = parts[1] ? (decimal + parts[1]) : '';
    return dollars + centsPart;
  }

  var match = format.match(placeholderRegex);
  var token = match ? match[1] : 'amount';
  var value;
  switch (token) {
    case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
    case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
    case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
    case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' '); break;
    case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
    default: value = formatWithDelimiters(cents, 2);
  }

  var formatted = format.replace(placeholderRegex, value);
  if (window.SHOP_CURRENCY) { formatted = formatted.replace(window.SHOP_CURRENCY, '').trim(); }
  return formatted;
}

function updateCartUI() {
  const cart = window.FranklinStore.cart;
  const counterBadge = document.getElementById('cart-counter');
  const badgeCount = document.getElementById('cart-badge-count');
  const itemsContainer = document.getElementById('cart-items-container');
  const emptyState = document.getElementById('cart-empty-state');

  const subtotalEl = document.getElementById('cart-subtotal');
  const discountEl = document.getElementById('cart-discount');
  const totalEl = document.getElementById('cart-total');
  const checkoutBtn = document.getElementById('checkout-btn');

  if (!counterBadge) return;

  const totalQty = cart.item_count || 0;
  const subtotal = cart.total_price || 0;

  // Dynamic badge styling
  if (totalQty > 0) {
    counterBadge.className = 'bg-[#D6FF00] text-black text-[10px] font-black px-2.5 py-0.5 rounded-full flex items-center justify-center shadow-[0_0_12px_rgba(214,255,0,0.45)] transition-all duration-300 tracking-tight';
  } else {
    counterBadge.className = 'bg-white/10 text-white/50 text-[10px] font-black px-2 py-0.5 rounded-full flex items-center justify-center transition-all duration-300 tracking-tight';
  }

  counterBadge.textContent = totalQty;
  if (badgeCount) badgeCount.textContent = `${totalQty} ${totalQty !== 1 ? ((window.themeStrings && window.themeStrings.items) || 'ITEMS') : ((window.themeStrings && window.themeStrings.item) || 'ITEM')}`;

  // Clear existing cart item nodes
  const currentItems = itemsContainer ? itemsContainer.querySelectorAll('.cart-item-node') : [];
  currentItems.forEach(el => el.remove());

  if (totalQty === 0) {
    if (emptyState) emptyState.style.display = 'flex';
    if (subtotalEl) subtotalEl.textContent = '$0.00';
    if (discountEl) discountEl.textContent = '-$0.00';
    if (totalEl) totalEl.textContent = '$0.00';
    if (checkoutBtn) checkoutBtn.disabled = true;
  } else {
    if (emptyState) emptyState.style.display = 'none';
    if (checkoutBtn) checkoutBtn.disabled = false;

    cart.items.forEach(item => {
      const row = document.createElement('div');
      row.className = 'cart-item-node flex items-center space-x-4 pb-4 border-b border-black/10';
      row.innerHTML = `
        <div class="w-16 h-16 bg-[#F9F9F9] border border-black/5 p-2 flex items-center justify-center flex-shrink-0">
          <img src="${item.image}" alt="${item.title}" class="max-h-full max-w-full object-contain">
        </div>
        <div class="flex-1 min-w-0 text-left">
          <h5 class="font-display font-black text-xs text-black truncate">${item.product_title}</h5>
          ${item.variant_title ? `<p class="text-[10px] text-black/50 flex items-center gap-1.5"><span class="inline-block w-3 h-3 rounded-full flex-shrink-0 border border-black/10" style="background-color: ${getColorHex(item.variant_title)};"></span>${item.variant_title}</p>` : ''}
          <div class="flex justify-between items-center mt-2.5">
            <div class="flex items-center space-x-2 bg-white border border-black/10 p-1 select-none">
              <button onclick="updateCartItemQty('${item.key}', ${item.quantity - 1})" class="w-5 h-5 hover:bg-[#D6FF00] hover:text-black text-black flex items-center justify-center text-xs focus:outline-none font-black">-</button>
              <span class="text-xs text-black font-black w-4 text-center">${item.quantity}</span>
              <button onclick="updateCartItemQty('${item.key}', ${item.quantity + 1})" class="w-5 h-5 hover:bg-[#D6FF00] hover:text-black text-black flex items-center justify-center text-xs focus:outline-none font-black">+</button>
            </div>
            <div class="flex items-center space-x-3">
              <span class="text-xs font-black text-black">${formatMoney(item.final_line_price)}</span>
              <button onclick="removeCartItem('${item.key}')" class="text-black/40 hover:text-red-600 p-1 transition-all">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
              </button>
            </div>
          </div>
        </div>
      `;
      if (itemsContainer) itemsContainer.appendChild(row);
    });

    if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);
    if (discountEl) discountEl.textContent = '-$0.00';
    if (totalEl) totalEl.textContent = formatMoney(subtotal);
  }
}

// 5. PRODUCT QUICK VIEW MODAL (uses Shopify product JSON)
function initQuickView() {
  let currentModalQty = 1;

  window.toggleQuickViewModal = function(open) {
    const modal = document.getElementById('quick-view-modal');
    const panel = document.getElementById('modal-panel');
    if (!modal || !panel) return;

    if (open) {
      modal.classList.remove('opacity-0', 'pointer-events-none');
      panel.classList.remove('scale-95');
    } else {
      modal.classList.add('opacity-0', 'pointer-events-none');
      panel.classList.add('scale-95');
    }
  };

  window.incrementModalQty = function() {
    currentModalQty++;
    const qtyInput = document.getElementById('modal-qty-input');
    if (qtyInput) qtyInput.value = currentModalQty;
  };

  window.decrementModalQty = function() {
    if (currentModalQty > 1) {
      currentModalQty--;
      const qtyInput = document.getElementById('modal-qty-input');
      if (qtyInput) qtyInput.value = currentModalQty;
    }
  };

  function renderStars(rating) {
    let starsHTML = '';
    const r = parseFloat(rating) || 5.0;
    for (let i = 1; i <= 5; i++) {
      if (i <= r) {
        starsHTML += `<svg class="w-3.5 h-3.5 fill-current text-[#D6FF00] stroke-black stroke-[1]" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"></path></svg>`;
      } else if (i - 0.5 <= r) {
        starsHTML += `<svg class="w-3.5 h-3.5 text-[#D6FF00] stroke-black stroke-[1] fill-current opacity-70" viewBox="0 0 20 20">
          <defs><linearGradient id="half"><stop offset="50%" stop-color="#D6FF00"/><stop offset="50%" stop-color="transparent"/></linearGradient></defs>
          <path fill="url(#half)" d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"></path>
        </svg>`;
      } else {
        starsHTML += `<svg class="w-3.5 h-3.5 stroke-black stroke-[1] fill-none text-zinc-300" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"></path></svg>`;
      }
    }
    return starsHTML;
  }

  window.selectQuickViewVariant = function(variantId) {
    const variant = window.currentQuickViewProduct.variants.find(v => v.id == variantId);
    if (!variant) return;

    window.currentQuickViewVariantId = variantId;

    // Update image
    const imgEl = document.getElementById('modal-product-img');
    if (imgEl && variant.featured_image && variant.featured_image.src) {
      imgEl.src = variant.featured_image.src;
    } else if (imgEl) {
      imgEl.src = window.currentQuickViewProduct.featured_image;
    }

    // Update price
    const priceEl = document.getElementById('modal-product-price');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    // Update compare-at-price and Save badge
    const comparePriceEl = document.getElementById('modal-product-compare-price');
    const saveBadgeEl = document.getElementById('modal-product-save-badge');
    if (comparePriceEl && saveBadgeEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceEl.classList.remove('hidden');
        
        const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        saveBadgeEl.textContent = `SAVE ${pct}%`;
        saveBadgeEl.classList.remove('hidden');
      } else {
        comparePriceEl.classList.add('hidden');
        saveBadgeEl.classList.add('hidden');
      }
    }

    // Update stock & button states
    const addBtn = document.getElementById('modal-add-btn');
    const stockPill = document.getElementById('modal-product-stock-pill');
    const stockDot = document.getElementById('modal-product-stock-dot');
    const stockText = document.getElementById('modal-product-stock-text');
    const specCollection = document.getElementById('modal-spec-collection');
    const badgeContainer = document.getElementById('modal-product-badge-container');

    let isAvailable = variant.available;
    let invQty = 999;
    let invMgmt = null;

    if (window.currentQuickViewInventory && window.currentQuickViewInventory[variantId]) {
      const invData = window.currentQuickViewInventory[variantId];
      isAvailable = invData.available;
      invQty = invData.inventory_quantity;
      invMgmt = invData.inventory_management;
    }

    if (badgeContainer) badgeContainer.innerHTML = '';

    if (!isAvailable) {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = (window.themeStrings && window.themeStrings.outOfStock) || 'OUT OF STOCK';
        addBtn.className = 'flex-1 h-12 bg-zinc-855 text-zinc-500 font-display font-black text-xs uppercase tracking-widest cursor-not-allowed border border-black/10 rounded-none flex items-center justify-center gap-2 opacity-50';
      }
      if (stockPill && stockDot && stockText) {
        stockPill.className = 'flex items-center gap-1.5 px-2.5 py-1 text-[10px] font-display font-black border border-black/10 text-black/40 bg-zinc-50 uppercase tracking-wider select-none';
        stockDot.className = 'w-2 h-2 rounded-full block bg-zinc-400';
        stockText.textContent = (window.themeStrings && window.themeStrings.outOfStock) || 'OUT OF STOCK';
      }
      if (specCollection) {
        specCollection.textContent = window.currentQuickViewCollection || '-';
        specCollection.className = 'font-black text-black uppercase';
      }
      if (badgeContainer) {
        badgeContainer.innerHTML = `<span class="bg-[#0C0E14] text-white/50 border border-white/10 text-[8px] font-sans font-black px-2 py-0.5 uppercase tracking-widest z-20 rounded-none shadow-sm select-none">${(window.themeStrings && window.themeStrings.outOfStock) || 'OUT OF STOCK'}</span>`;
      }
    } else {
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.textContent = (window.themeStrings && window.themeStrings.addToCart) || 'ADD TO CART';
        addBtn.className = 'flex-1 h-12 bg-black hover:bg-[#D6FF00] text-white hover:text-black font-display font-black text-xs uppercase tracking-widest transition-colors duration-300 border border-black rounded-none flex items-center justify-center gap-2';
      }

      const isLowStock = invMgmt === 'shopify' && invQty > 0 && invQty <= 5;
      if (isLowStock) {
        if (stockPill && stockDot && stockText) {
          stockPill.className = 'flex items-center gap-1.5 px-2.5 py-1 text-[10px] font-display font-black border border-red-500 text-red-600 bg-red-50 uppercase tracking-wider select-none';
          stockDot.className = 'w-2 h-2 rounded-full block bg-red-600 animate-pulse';
          stockText.textContent = (window.themeStrings && window.themeStrings.sellingFast) || 'SELLING FAST';
        }
        if (specCollection) {
          const tags = (window.currentQuickViewProduct && window.currentQuickViewProduct.tags) || [];
          specCollection.textContent = tags[0] || 'ALL';
          specCollection.className = 'font-black text-black uppercase';
        }
        if (badgeContainer) {
          badgeContainer.innerHTML = `<span class="bg-red-600 text-white text-[8px] font-sans font-black px-2 py-0.5 uppercase tracking-widest z-20 rounded-none shadow-sm select-none">${(window.themeStrings && window.themeStrings.sellingFast) || 'SELLING FAST'}</span>`;
        }
      } else {
        if (stockPill && stockDot && stockText) {
          stockPill.className = 'flex items-center gap-1.5 px-2.5 py-1 text-[10px] font-display font-black border border-[#D6FF00] text-black bg-[#D6FF00]/10 uppercase tracking-wider select-none';
          stockDot.className = 'w-2 h-2 rounded-full block bg-green-500';
          stockText.textContent = (window.themeStrings && window.themeStrings.inStock) || 'IN STOCK';
        }
        if (specCollection) {
          const tags = (window.currentQuickViewProduct && window.currentQuickViewProduct.tags) || [];
          specCollection.textContent = tags[0] || 'ALL';
          specCollection.className = 'font-black text-black uppercase';
        }
        // Badge based on tags
        const tags = window.currentQuickViewProduct.tags || [];
        if (badgeContainer && tags.length > 0) {
          let badgeText = '';
          if (tags.includes('new') || tags.includes('NEW')) badgeText = 'NEW';
          else if (tags.includes('best seller') || tags.includes('BEST SELLER')) badgeText = 'BEST SELLER';
          else if (tags.includes('limited edition') || tags.includes('LIMITED EDITION')) badgeText = 'LIMITED EDITION';
          
          if (badgeText) {
            badgeContainer.innerHTML = `<span class="bg-black text-white text-[8px] font-sans font-black px-2 py-0.5 uppercase tracking-widest z-20 rounded-none shadow-sm select-none">${badgeText}</span>`;
          }
        }
      }
    }

    // Update active class on color swatch buttons
    const varContainer = document.getElementById('modal-product-variants');
    if (varContainer) {
      Array.from(varContainer.children).forEach(btn => {
        if (btn.dataset.variantId == variantId) {
          btn.className = 'variant-swatch relative w-9 h-9 rounded-full transition-all duration-200 flex items-center justify-center ring-2 ring-offset-2 ring-black';
        } else {
          btn.className = 'variant-swatch relative w-9 h-9 rounded-full transition-all duration-200 flex items-center justify-center ring-1 ring-black/20 hover:ring-2 hover:ring-offset-2 hover:ring-black/40';
        }
        // Re-add white border for white swatches
        if (getColorHex(btn.dataset.colorName) === '#FFFFFF') {
          if (!btn.querySelector('span')) {
            btn.innerHTML = '<span class="absolute inset-0 rounded-full border border-black/15"></span>';
          }
        }
      });
    }

    // Update selected color label
    const colorLabel = document.getElementById('modal-selected-color-label');
    const activeBtn = varContainer?.querySelector(`[data-variant-id="${variantId}"]`);
    if (colorLabel && activeBtn) {
      colorLabel.textContent = '— ' + activeBtn.dataset.colorName;
    }
  };

  window.openQuickView = function(productHandle, triggerEl) {
    // Read variant stock json from data attribute
    window.currentQuickViewInventory = null;
    window.currentQuickViewCollection = (triggerEl && triggerEl.dataset && triggerEl.dataset.collection) || '';
    if (triggerEl && triggerEl.dataset && triggerEl.dataset.variantsStock) {
      try {
        window.currentQuickViewInventory = JSON.parse(triggerEl.dataset.variantsStock);
      } catch (e) {
        console.error('Failed to parse variant stock map:', e);
      }
    }

    currentModalQty = 1;
    const qtyInput = document.getElementById('modal-qty-input');
    if (qtyInput) qtyInput.value = 1;

    const root = getRouteRoot();
    fetch(root + 'products/' + productHandle + '.js')
      .then(res => res.json())
      .then(product => {
        window.currentQuickViewProduct = product;
        
        const imgEl = document.getElementById('modal-product-img');
        const titleEl = document.getElementById('modal-product-title');
        const priceEl = document.getElementById('modal-product-price');
        const descEl = document.getElementById('modal-product-desc');
        const ratingEl = document.getElementById('modal-product-rating');
        const starsEl = document.getElementById('modal-product-stars');
        const vendorEl = document.getElementById('modal-product-vendor');
        const typeEl = document.getElementById('modal-product-type');
        const specCategoryEl = document.getElementById('modal-spec-category');

        if (imgEl) imgEl.src = product.featured_image;
        if (titleEl) titleEl.textContent = product.title;
        if (priceEl) priceEl.textContent = formatMoney(product.price);
        if (descEl) descEl.innerHTML = product.description;
        if (vendorEl) vendorEl.textContent = product.vendor || 'FRANKLIN SPORTS';
        if (typeEl) typeEl.textContent = product.type || 'GEAR';
        if (specCategoryEl) specCategoryEl.textContent = product.type || 'GEAR';

        // Reviews mockup
        const rate = (4.5 + (product.title.length % 6) * 0.1).toFixed(1);
        const count = 25 + (product.title.length * 7) % 350;
        if (starsEl) starsEl.innerHTML = renderStars(rate);
        if (ratingEl) ratingEl.textContent = `${rate} (${count} ${(window.themeStrings && window.themeStrings.reviews) || 'reviews'})`;

        // Render variants as color swatches
        const variantsWrapper = document.getElementById('modal-product-variants-wrapper');
        const variantsContainer = document.getElementById('modal-product-variants');
        if (variantsWrapper && variantsContainer) {
          if (product.variants && product.variants.length > 1) {
            variantsWrapper.classList.remove('hidden');
            variantsContainer.innerHTML = '';
            product.variants.forEach((variant, idx) => {
              const hex = getColorHex(variant.title);
              const btn = document.createElement('button');
              btn.className = 'variant-swatch relative w-9 h-9 rounded-full transition-all duration-200 flex items-center justify-center ' + (idx === 0 ? 'ring-2 ring-offset-2 ring-black' : 'ring-1 ring-black/20 hover:ring-2 hover:ring-offset-2 hover:ring-black/40');
              btn.style.backgroundColor = hex;
              btn.title = variant.title;
              btn.dataset.variantId = variant.id;
              btn.dataset.colorName = variant.title;
              if (hex === '#FFFFFF') {
                btn.innerHTML = '<span class="absolute inset-0 rounded-full border border-black/15"></span>';
              }
              btn.onclick = () => window.selectQuickViewVariant(variant.id);
              variantsContainer.appendChild(btn);
            });
          } else {
            variantsWrapper.classList.add('hidden');
          }
        }

        // Select first variant initially
        const firstVariantId = product.variants[0].id;
        window.selectQuickViewVariant(firstVariantId);

        // Bind main Add to Cart
        const modalAddBtn = document.getElementById('modal-add-btn');
        if (modalAddBtn) {
          modalAddBtn.onclick = function() {
            addToCart(window.currentQuickViewVariantId, currentModalQty, this);
            setTimeout(() => toggleQuickViewModal(false), 800);
          };
        }

        toggleQuickViewModal(true);
      })
      .catch(err => console.error('Quick view error:', err));
  };
}

// 7. PREMIUM MEGA MENU CONTROLLERS
// megaMenuData is now generated by Liquid in header.liquid

window.isMegaOpen = false;
window.currentMegaKey = null;

window.updateNavActiveState = function(activeKey) {
  const triggers = document.querySelectorAll('.mega-trigger');
  triggers.forEach(trig => {
    trig.classList.remove('text-[#D6FF00]', 'text-red-500', 'text-white/80', 'text-white');
    if (trig.id === 'mega-trigger-sale') {
      trig.classList.add('text-red-500');
    } else {
      trig.classList.add('text-white/80');
    }
  });

  const lines = document.querySelectorAll('.mega-trigger-line');
  lines.forEach(line => {
    line.classList.remove('w-full');
    line.classList.add('w-0');
  });

  if (activeKey) {
    const activeTrig = document.getElementById(`mega-trigger-${activeKey}`);
    const activeLine = document.getElementById(`mega-line-${activeKey}`);
    if (activeTrig) {
      activeTrig.classList.remove('text-white/80', 'text-red-500');
      if (activeKey === 'sale') {
        activeTrig.classList.add('text-red-500');
      } else {
        activeTrig.classList.add('text-[#D6FF00]');
      }
    }
    if (activeLine) {
      activeLine.classList.remove('w-0');
      activeLine.classList.add('w-full');
    }
  }
};

window.toggleMegaMenu = function(event, key) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  const menu = document.getElementById('desktop-mega-menu');
  if (!menu) return;

  if (window.isMegaOpen && window.currentMegaKey === key) {
    window.closeMegaMenu();
    return;
  }

  window.currentMegaKey = key;
  window.isMegaOpen = true;

  window.updateNavActiveState(key);

  menu.classList.remove('opacity-0', 'pointer-events-none', 'translate-y-[-10px]');
  menu.classList.add('opacity-100', 'pointer-events-auto', 'translate-y-0');

  const tabsList = document.getElementById('mega-tabs-list');
  if (tabsList) {
    const cat = window.megaMenuData[key];
    if (cat && cat.tabs) {
      tabsList.innerHTML = cat.tabs.map((tab, idx) => `
        <div onclick="window.selectMegaCategory(this, '${key}', ${idx})" class="mega-menu-tab flex items-center justify-between px-8 py-3.5 cursor-pointer text-xs font-bold uppercase tracking-widest text-white/60 border-l-2 border-transparent hover:text-white hover:bg-white/5 transition-all">
          <span>${tab.title}</span>
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7"></path></svg>
        </div>
      `).join('');

      const firstTab = tabsList.querySelector('.mega-menu-tab');
      if (firstTab) {
        window.selectMegaCategory(firstTab, key, 0);
      }
    }
  }

  document.addEventListener('click', window.closeMegaMenuOutside);
};

window.closeMegaMenu = function() {
  const menu = document.getElementById('desktop-mega-menu');
  if (!menu) return;

  window.isMegaOpen = false;
  window.currentMegaKey = null;
  menu.classList.add('opacity-0', 'pointer-events-none', 'translate-y-[-10px]');
  menu.classList.remove('opacity-100', 'pointer-events-auto', 'translate-y-0');

  window.updateNavActiveState(null);

  document.removeEventListener('click', window.closeMegaMenuOutside);
};

window.closeMegaMenuOutside = function(e) {
  const menu = document.getElementById('desktop-mega-menu');
  if (e.target.closest('.mega-trigger')) return;
  if (menu && !menu.contains(e.target)) {
    window.closeMegaMenu();
  }
};

window.selectMegaCategory = function(tabElement, key, index) {
  const cat = window.megaMenuData[key];
  if (!cat || !cat.tabs || !cat.tabs[index]) return;

  const tab = cat.tabs[index];

  const tabs = document.querySelectorAll('.mega-menu-tab');
  tabs.forEach(t => {
    t.className = "mega-menu-tab flex items-center justify-between px-8 py-3.5 cursor-pointer text-xs font-bold uppercase tracking-widest text-white/60 border-l-2 border-transparent hover:text-white hover:bg-white/5 transition-all";
  });

  if (key === 'sale') {
    tabElement.className = "mega-menu-tab flex items-center justify-between px-8 py-3.5 cursor-pointer text-xs font-bold uppercase tracking-widest text-red-500 border-l-2 border-red-500 bg-white/5 transition-all";
  } else {
    tabElement.className = "mega-menu-tab flex items-center justify-between px-8 py-3.5 cursor-pointer text-xs font-bold uppercase tracking-widest text-[#D6FF00] border-l-2 border-[#D6FF00] bg-white/5 transition-all";
  }

  const title = document.getElementById('mega-category-title');
  const grid = document.getElementById('mega-submenu-grid');
  const promoWrapper = document.getElementById('mega-promo-card-wrapper');

  if (!title || !grid || !promoWrapper) return;

  grid.classList.add('opacity-0', 'translate-y-2');
  promoWrapper.classList.add('opacity-0', 'translate-y-2');

  setTimeout(() => {
    const editableTitle = tab.menuTitle ? tab.menuTitle.trim() : '';
    title.textContent = editableTitle || tab.title || cat.title;
    grid.innerHTML = tab.submenu.map(sub => `
      <a href="${sub.link}" onclick="window.closeMegaMenu()" class="text-xs font-display font-medium tracking-wide text-white/80 hover:text-[#D6FF00] border-b border-white/5 pb-2.5 transition-colors uppercase block">
        ${sub.name}
      </a>
    `).join('');

    if (tab.promo && tab.promo.image) {
      promoWrapper.innerHTML = `
        <img src="${tab.promo.image}" alt="${tab.promo.title}" class="absolute inset-0 w-full h-full object-cover group-hover/promo:scale-105 transition-transform duration-700 ease-out z-0">
        <div class="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent z-10"></div>

        <div class="relative z-20 p-5 flex flex-col justify-end items-start">
          <span class="text-[8px] font-black text-[#D6FF00] tracking-widest uppercase mb-1">FEATURED INSIDER</span>
          <a href="${tab.promo.link}" onclick="window.closeMegaMenu()" class="bg-black hover:bg-[#D6FF00] text-white hover:text-black font-display font-black text-xs px-4 py-2 uppercase tracking-widest flex items-center space-x-2 transition-all">
            <span>${tab.promo.title}</span>
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7"></path></svg>
          </a>
        </div>
      `;
      promoWrapper.style.display = '';
    } else {
      promoWrapper.innerHTML = '';
      promoWrapper.style.display = 'none';
    }

    grid.classList.remove('opacity-0', 'translate-y-2');
    promoWrapper.classList.remove('opacity-0', 'translate-y-2');
  }, 150);
};

window.currentMobileLevel = 0;

window.slideMobileLevel = function(level) {
  window.currentMobileLevel = level;
  const slider = document.getElementById('mobile-nav-slider');
  if (slider) {
    slider.style.transform = `translateX(-${(level * 100) / 3}%)`;
  }
};

window.toggleMobileNav = function(open) {
  const drawer = document.getElementById('mobile-nav');
  const panel = document.getElementById('mobile-nav-panel');
  if (!drawer || !panel) return;

  if (open) {
    window.slideMobileLevel(0);
    window.populateMobileCategories();
    drawer.classList.remove('opacity-0', 'pointer-events-none');
    panel.classList.remove('translate-x-full');
    drawer.classList.add('is-open');
  } else {
    drawer.classList.add('opacity-0', 'pointer-events-none');
    panel.classList.add('translate-x-full');
    drawer.classList.remove('is-open');
  }
};

window.populateMobileCategories = function() {
  const listContainer = document.getElementById('mobile-categories-list');
  if (!listContainer) return;
  listContainer.innerHTML = '';

  Object.keys(window.megaMenuData).forEach(key => {
    const cat = window.megaMenuData[key];
    const arrow = cat.tabs ? `<svg class="w-3.5 h-3.5 text-sport-accent transform group-hover/mcat:translate-x-1.5 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"></path></svg>` : '';
    const item = document.createElement('button');
    item.className = 'w-full flex items-center justify-between border border-white/5 p-3.5 hover:bg-white/5 text-white/90 hover:text-white transition-all text-left text-xs font-bold uppercase tracking-widest focus:outline-none group/mcat';
    if (key === 'sale') {
      item.innerHTML = `<span class="text-red-500 font-black">${cat.title}</span>${arrow}`;
    } else {
      item.innerHTML = `<span>${cat.title}</span>${arrow}`;
    }
    item.onclick = () => {
      if (cat.tabs) {
        window.selectMobileCategory(key);
      } else {
        window.toggleMobileNav(false);
        window.location.hash = '#shop';
      }
    };
    listContainer.appendChild(item);
  });
};

window.selectMobileCategory = function(key) {
  const cat = window.megaMenuData[key];
  if (!cat) return;

  const titleEl = document.getElementById('mobile-sub-category-title');
  if (titleEl) titleEl.textContent = cat.title;

  const subContainer = document.getElementById('mobile-subcategories-list');
  if (subContainer) {
    subContainer.innerHTML = '';
    cat.tabs.forEach(tab => {
      const titleDiv = document.createElement('div');
      titleDiv.className = 'text-[9px] text-sport-accent font-black tracking-widest uppercase mt-5 mb-2.5 border-b border-white/10 pb-1.5';
      titleDiv.textContent = tab.title;
      subContainer.appendChild(titleDiv);

      tab.submenu.forEach(sub => {
        const a = document.createElement('a');
        a.href = sub.link;
        a.className = 'border border-white/5 bg-white/5 p-3.5 hover:bg-sport-accent hover:text-black transition-all block text-left text-xs font-bold uppercase tracking-wider hover:translate-x-1 duration-300';
        a.textContent = sub.name;
        a.onclick = () => window.toggleMobileNav(false);
        subContainer.appendChild(a);
      });
    });
  }

  window.slideMobileLevel(2);
};

// 8. PRODUCT PAGE - Variant selector (color swatch design)
window.selectVariant = function(variantId, button, colorName) {
  const container = button.closest('[data-product-form]');
  if (!container) return;

  const input = container.querySelector('input[name="id"]');
  if (input) input.value = variantId;

  // Update active state on color swatch buttons
  container.querySelectorAll('.variant-btn').forEach(btn => {
    if (btn.style.backgroundColor) {
      btn.className = "variant-btn relative w-9 h-9 rounded-full transition-all duration-200 flex items-center justify-center ring-1 ring-zinc-200 hover:ring-2 hover:ring-offset-2 hover:ring-zinc-400";
    } else {
      btn.className = "variant-btn px-4 py-2 border border-zinc-200 font-display font-black text-xs uppercase tracking-wider transition-colors duration-300 bg-white text-black hover:bg-black/5";
    }
  });
  if (button.style.backgroundColor) {
    button.className = "variant-btn relative w-9 h-9 rounded-full transition-all duration-200 flex items-center justify-center ring-2 ring-offset-2 ring-zinc-900";
  } else {
    button.className = "variant-btn px-4 py-2 border border-zinc-900 font-display font-black text-xs uppercase tracking-wider transition-colors duration-300 bg-black text-white";
  }

  // Update selected color label
  const label = document.getElementById('selected-color-label');
  if (label && colorName) {
    label.textContent = '— ' + colorName;
  }

  // Update price display
  const priceEl = container.closest('.product-page')?.querySelector('.product-price');
  const variantData = button.dataset.price;
  if (priceEl && variantData) {
    priceEl.textContent = formatMoney(parseInt(variantData));
  }

  // Update product image if variant has its own image
  const variantImage = button.dataset.image;
  const mainImg = document.getElementById('product-main-image');
  if (mainImg && variantImage) {
    mainImg.classList.add('opacity-0');
    setTimeout(() => {
      mainImg.src = variantImage;
      mainImg.classList.remove('opacity-0');
    }, 150);
  }

  // Update URL without reload
  const url = new URL(window.location);
  url.searchParams.set('variant', variantId);
  history.replaceState(null, '', url);
};
